import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { PriceTable, RegularBenefitVariant } from '../../../../../../../typings'
import { messages } from './messages'

export function validationPriceTable(intl: IntlShape) {
  return create(({ value, type }: PriceTable) => {
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.PriceTable, () => {
      test('value', $t(validation.required), () => {
        enforce(value).isNotEmpty()
      })
    })
  })
}
